import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink } from "react-router-dom";
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";

function AddLeavePolicy() {
    const getBranchId = (branch) => branch?.branch_id ?? branch?.branchid ?? null;
    const getBranchCode = (branch) => branch?.branch_code ?? branch?.branchcode ?? '';
    const getBranchName = (branch) => branch?.branch_name ?? branch?.branchname ?? '';

    const branchSelectorStyles = {
        wrapper: {
            position: "relative"
        },
        trigger: {
            minHeight: "46px",
            border: "1px solid #d7deea",
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            boxShadow: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            cursor: "pointer"
        },
        triggerText: {
            fontSize: "0.98rem",
            color: "#52637d",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingRight: "12px"
        },
        triggerIcon: {
            fontSize: "0.9rem",
            color: "#70819b",
            flexShrink: 0
        },
        dropdown: {
            position: "absolute",
            top: "calc(100% + 8px)",
            left: 0,
            right: 0,
            zIndex: 20,
            border: "1px solid #d7deea",
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            boxShadow: "0 8px 18px rgba(31, 45, 61, 0.12)",
            overflow: "hidden"
        },
        header: {
            display: "flex",
            alignItems: "center",
            padding: "10px 14px",
            background: "linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%)",
            borderBottom: "1px solid #e4ebf5"
        },
        headerText: {
            fontSize: "0.85rem",
            fontWeight: 600,
            color: "#4b5b76"
        },
        list: {
            maxHeight: "190px",
            overflowY: "auto",
            overflowX: "hidden",
            padding: "6px"
        },
        item: {
            display: "flex",
            alignItems: "flex-start",
            gap: "8px",
            padding: "6px 10px",
            marginBottom: "4px",
            borderRadius: "2px",
            cursor: "pointer",
            transition: "background-color 0.2s ease"
        },
        checkbox: {
            marginTop: "2px",
            width: "14px",
            height: "14px",
            accentColor: "#2f5bea",
            flexShrink: 0
        },
        label: {
            marginBottom: 0,
            fontSize: "0.92rem",
            fontWeight: 400,
            color: "#2f3b52",
            lineHeight: "1.2",
            wordBreak: "break-word"
        }
    };


    const [isTableVisible, setIsTableVisible] = useState(false);
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");


    const navigate = useNavigate();
    const Swal = require('sweetalert2')
    const branchDropdownRef = useRef(null);

    const [leaveTypes, setLeaveTypes] = useState([]);
    const [leavepolices, setleavepolices] = useState([]);
    const [selectedLeaveId, setSelectedLeaveId] = useState('');
    const [selectedLeaves, setSelectedLeaves] = useState([]);

    const [branches, setBranches] = useState([]);
    const [selectedBranchCodes, setSelectedBranchCodes] = useState([]);
    const [isBranchDropdownOpen, setIsBranchDropdownOpen] = useState(false);

    const [showStaffModal, setShowStaffModal] = useState(false);
    const [policyno, setpolicyno] = useState('');
    const groupedSelectedLeaves = selectedLeaves.reduce((acc, leave) => {
        if (!acc.some((item) => item.leaveid === leave.leaveid)) {
            acc.push(leave);
        }
        return acc;
    }, []);


    const [branchList, setBranchList] = useState([]);
    const [staffByBranch, setStaffByBranch] = useState({});
    const [showStaff, setShowStaff] = useState(false);

    const [selectedStaffList, setSelectedStaffList] = useState([]);
    const [affectedFromDate, setAffectedFromDate] = useState(
        new Date().toISOString().split("T")[0]
    );

    const [affectedToDate, setAffectedToDate] = useState("");

    const [isStaffCheckbox, setIsStaffCheckbox] = useState(false);
    const [staffList, setStaffList] = useState([]);

    // levpo_flag: when checked, this policy applies to all staff
    const [levpoFlag, setLevpoFlag] = useState(false);
    const [loading, setLoading] = useState(false);




    const fetchStaffByBranches = async () => {
        const branchIds = selectedLeaves.map(b => b.branchid);

        try {
            const res = await fetch(baseurladdress + "getstaffbybranches", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
                body: JSON.stringify({
                    branches: branchIds
                })
            });

            const data = await res.json();

            if (data.response) {
                // group by branch name
                const grouped = data.response.reduce((acc, staff) => {
                    const key = staff.branch_id;

                    if (!acc[key]) acc[key] = [];

                    acc[key].push(staff);

                    return acc;
                }, {});

                setStaffByBranch(grouped);
            }
        } catch (err) {
            console.error("Staff fetch error:", err);
        }
    };
    const handleSelectStaff = (staff) => {
        setSelectedStaffList((prev) => {
            const exists = prev.some((s) => s.staff_id === staff.staff_id);

            if (exists) {
                return prev.filter((s) => s.staff_id !== staff.staff_id);
            }

            return [...prev, staff];
        });
    };

    const handleStaffCheckboxChange = async (e) => {
        const checked = e.target.checked;
        setIsStaffCheckbox(checked);

        if (checked) {
            await fetchStaffByBranches(); // must depend on selectedLeaves
        } else {
            setStaffByBranch({});
            setSelectedStaffList([]);
        }
    };

    const handleSelectChange = (e) => {
        setSelectedLeaveId(e.target.value);
    };

    const handleSelectAllBranches = (e) => {
        if (e.target.checked) {
            setSelectedBranchCodes(branches.map((branch) => getBranchCode(branch)).filter(Boolean));
            return;
        }

        setSelectedBranchCodes([]);
    };

    const handleBranchCheckboxChange = (branchCode) => {
        setSelectedBranchCodes((prev) =>
            prev.includes(branchCode)
                ? prev.filter((code) => code !== branchCode)
                : [...prev, branchCode]
        );
    };

    const getBranchTriggerText = () => {
        if (selectedBranchCodes.length === 0) {
            return "Choose Branch";
        }

        if (selectedBranchCodes.length === branches.length && branches.length > 0) {
            return "All Branches Selected";
        }

        const selectedNames = branches
            .filter((branch) => selectedBranchCodes.includes(getBranchCode(branch)))
            .map((branch) => getBranchName(branch));

        return selectedNames.join(", ");
    };




    const handleButtonClickk = async () => {
        const leave = leaveTypes.find(item => item.leaveid === parseInt(selectedLeaveId));
        const selectedBranchList = branches.filter((branch) =>
            selectedBranchCodes.includes(getBranchCode(branch))
        );

        if (!leave || selectedBranchList.length === 0) return;

        const alreadySelectedBranches = selectedBranchList.filter((branch) =>
            selectedLeaves.some(
                (policy) =>
                    String(policy.branchid) === String(getBranchId(branch)) &&
                    policy.leaveid === parseInt(selectedLeaveId)
            )
        );

        if (alreadySelectedBranches.length === selectedBranchList.length) {
            Swal.fire({
                icon: "warning",
                title: "Already Added",
                text: "This leave type is already added for the selected branch(es).",
                confirmButtonText: "OK"
            });
            return;
        }

        const duplicateBranches = selectedBranchList.filter((selectedBranch) =>
            leavepolices.some(policy => {
                const cleanedLeaveTypes = policy.leavepolicy_leavetype
                    .split(',')
                    .map(s => s.trim().toLowerCase());

                return (
                    policy.leavepolicy_branchname === getBranchName(selectedBranch) &&
                    cleanedLeaveTypes.includes(leave.leave_type.toLowerCase())
                );
            }));

        if (duplicateBranches.length > 0) {
            const result = await Swal.fire({
                title: "Duplicate Found",
                text: "Some selected branches already have this leave type in leave policies. Do you still want to add it?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, add it!",
                cancelButtonText: "No, cancel"
            });

            if (!result.isConfirmed) return;
        }

        const newLeaves = selectedBranchList
            .filter((selectedBranch) =>
                !selectedLeaves.some(
                    (policy) =>
                        String(policy.branchid) === String(getBranchId(selectedBranch)) &&
                        policy.leaveid === parseInt(selectedLeaveId)
                )
            )
            .map((selectedBranch) => ({
                ...leave,
                branchid: getBranchId(selectedBranch),
                branchcode: getBranchCode(selectedBranch),
                branchname: getBranchName(selectedBranch)
            }));

        if (newLeaves.length === 0) {
            return;
        }

        setSelectedLeaves(prev => [...prev, ...newLeaves]);

        if (!isTableVisible) {
            setIsTableVisible(true);
        }
        setSelectedLeaveId("");
    };






    const handleDelete = (branchid, leaveid) => {
        setSelectedLeaves(prev => {
            const updatedLeaves = prev.filter(
                (leave) => !(leave.branchid === branchid && leave.leaveid === leaveid)
            );
            setIsTableVisible(updatedLeaves.length > 0);
            return updatedLeaves;
        });
    };

    const handleDeleteByLeaveType = (leaveid) => {
        setSelectedLeaves((prev) => {
            const updatedLeaves = prev.filter((leave) => leave.leaveid !== leaveid);
            setIsTableVisible(updatedLeaves.length > 0);
            return updatedLeaves;
        });
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const [staffRes, branchRes] = await Promise.all([
                    axios.get(baseurladdress + "findallstaff", {
                        headers: { Authorization: `Bearer ${accesstoken}` }
                    }),
                    axios.get(baseurladdress + "getallbranchs", {
                        headers: { Authorization: `Bearer ${accesstoken}` }
                    })
                ]);

                setStaffList(staffRes.data.response || []);
                setBranchList(branchRes.data.response || []);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (!staffList.length || !branchList.length) return;

        const grouped = {};

        staffList.forEach((staff) => {
            const branch = branchList.find(
                (b) => String(b.branch_id) === String(staff.staff_placedat)
            );

            const branchName = branch?.branch_name || "Unknown Branch";

            if (!grouped[branchName]) {
                grouped[branchName] = [];
            }

            grouped[branchName].push(staff);
        });

        setStaffByBranch(grouped);
    }, [staffList, branchList]);


    useEffect(() => {
        const getbranch = () => {
            axios.get(baseurladdress + `findallbranches`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    setBranches(data);
                })
                .catch(error => {
                    alert(error);
                });
        };
        getbranch()




    }, [])
    useEffect(() => {
        axios.get(baseurladdress + `findallleaves`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const active = res.data.response.filter(item => item.leave_status === 1);
                setLeaveTypes(active);
            })
            .catch(error => {
                alert(error);
            });
    }, []);

    useEffect(() => {
        axios.get(baseurladdress + `findleavepolicy`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const active = res.data.response.filter(item => item.leavepolicy_status === 1);
                setleavepolices(active);
            })
            .catch(error => {
                alert(error);
            });
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (branchDropdownRef.current && !branchDropdownRef.current.contains(event.target)) {
                setIsBranchDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);




 const handleSubmit = async () => {
    if (!policyno || selectedLeaves.length === 0) {
        Swal.fire('Error', 'Enter policy number and select leaves', 'error');
        return;
    }

    setLoading(true);

    const data = {
        leavepolicy_num: policyno,
        userid: accessuserid,
        levpo_affectedfrom: affectedFromDate,
        levpo_affectedto: affectedToDate,
        levpo_flag: levpoFlag ? 1 : 0,

        // 👇 send ALL leaves in ONE request
        leaves: selectedLeaves.map(leave => ({
            leavepolicy_branchid: leave.branchid,
            leavepolicy_branchname: leave.branchname,
            leavepolicy_leavetypeid: leave.leaveid,
            leavepolicy_leavetype: leave.leave_type,
            leavepolicy_leavealloted: leave.max_leave
        }))
    };

    try {
        const res = await fetch(baseurladdress + "addleavepolicy", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data)
        });

        const result = await res.json();

        if (result.status === "success") {
            Swal.fire("Success", "Saved successfully", "success");
            navigate("/leavepolicy");
        } else {
            Swal.fire("Error", result.message, "error");
        }

    } catch (err) {
        console.error(err);
        Swal.fire("Error", "Server error", "error");
    } finally {
        setLoading(false);
    }
};





    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/leavepolicy"}>
                        <div style={{ display: "flex" }}>
                            <a className="float">
                                <i className="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>

                    <form>
                        <div className='row'>
                            <div className="col-xl-12 col-xxl-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Add Leave Policy</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="basic-form">
                                            <div className='row'>
                                                <div className="col-xl-6 col-xxl-12">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="basic-form">
                                                                <div className="form-row">


                                                                    <div class="col-sm-3 mt-3 mt-sm-0">
                                                                        <h6>Policy</h6>
                                                                        <input type="text"
                                                                            class="form-control"
                                                                            placeholder='Policy'
                                                                            value={policyno}
                                                                            onChange={(e) => setpolicyno(e.target.value)}
                                                                        />
                                                                    </div>





                                                                    <div className="col-sm-4 mt-3 mt-sm-0">
                                                                        <h6>Branch</h6>
                                                                        <div
                                                                            style={branchSelectorStyles.wrapper}
                                                                            ref={branchDropdownRef}
                                                                        >
                                                                            <div
                                                                                style={branchSelectorStyles.trigger}
                                                                                onClick={() => setIsBranchDropdownOpen((prev) => !prev)}
                                                                            >
                                                                                <span style={branchSelectorStyles.triggerText}>
                                                                                    {getBranchTriggerText()}
                                                                                </span>
                                                                                <i
                                                                                    className={`fa ${isBranchDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"}`}
                                                                                    style={branchSelectorStyles.triggerIcon}
                                                                                ></i>
                                                                            </div>

                                                                            {isBranchDropdownOpen && (
                                                                                <div style={branchSelectorStyles.dropdown}>
                                                                                    <div style={branchSelectorStyles.header}>
                                                                                        <span style={branchSelectorStyles.headerText}>Choose Branches</span>
                                                                                    </div>

                                                                                    <div style={branchSelectorStyles.list}>
                                                                                        <label
                                                                                            htmlFor="select-all-branches"
                                                                                            style={{
                                                                                                ...branchSelectorStyles.item,
                                                                                                backgroundColor: branches.length > 0 && selectedBranchCodes.length === branches.length ? "#edf3ff" : "#f8faff",
                                                                                                border: branches.length > 0 && selectedBranchCodes.length === branches.length ? "1px solid #bfd2ff" : "1px solid #edf1f7"
                                                                                            }}
                                                                                        >
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id="select-all-branches"
                                                                                                checked={branches.length > 0 && selectedBranchCodes.length === branches.length}
                                                                                                onChange={handleSelectAllBranches}
                                                                                                style={branchSelectorStyles.checkbox}
                                                                                            />
                                                                                            <span style={{ ...branchSelectorStyles.label, fontWeight: 700 }}>
                                                                                                Select All Branches
                                                                                            </span>
                                                                                        </label>

                                                                                        {branches.map((item) => {
                                                                                            const branchCode = getBranchCode(item);
                                                                                            const branchId = getBranchId(item);
                                                                                            const isChecked = selectedBranchCodes.includes(branchCode);

                                                                                            return (
                                                                                                <label
                                                                                                    htmlFor={`branch-${branchId}`}
                                                                                                    key={`${branchId}-${branchCode}`}
                                                                                                    style={{
                                                                                                        ...branchSelectorStyles.item,
                                                                                                        backgroundColor: isChecked ? "#edf3ff" : "#ffffff",
                                                                                                        border: isChecked ? "1px solid #bfd2ff" : "1px solid #edf1f7"
                                                                                                    }}
                                                                                                >
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        id={`branch-${branchId}`}
                                                                                                        checked={isChecked}
                                                                                                        onChange={() => handleBranchCheckboxChange(branchCode)}
                                                                                                        style={branchSelectorStyles.checkbox}
                                                                                                    />
                                                                                                    <span style={branchSelectorStyles.label}>
                                                                                                        {getBranchName(item)}
                                                                                                    </span>
                                                                                                </label>
                                                                                            );
                                                                                        })}
                                                                                    </div>




                                                                                </div>
                                                                            )}
                                                                        </div>


                                                                    </div>

                                                                    <div className="col-sm-4 mt-3 mt-sm-0">
                                                                        <h6>Type</h6>
                                                                        <select className="form-control" onChange={handleSelectChange} value={selectedLeaveId}>
                                                                            <option value="">Choose</option>
                                                                            {leaveTypes.map(item => (
                                                                                <option key={item.leaveid} value={item.leaveid}>
                                                                                    {item.leave_type}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div >
                                                                    <button
                                                                        type="button"
                                                                        className="btn plus-icon"
                                                                        style={{ border: "none" }}
                                                                        data-tooltip-id="mytooltip"
                                                                        onClick={handleButtonClickk}
                                                                        disabled={!selectedLeaveId || selectedBranchCodes.length === 0}
                                                                    >
                                                                        <span style={{ fontSize: "1.2rem" }}>+</span>
                                                                        <span style={{ fontSize: "0.7rem", marginLeft: "0.2rem", color: "black" }}>Add</span>
                                                                    </button>

                                                                </div>
                                                                <div className="form-row">
                                                                    <div className="col-sm-4 mt-3">
                                                                        <h6>Affected From</h6>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            value={affectedFromDate}
                                                                            onChange={(e) => setAffectedFromDate(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    <div className="col-sm-4 mt-3">
                                                                        <h6>Affected To</h6>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            value={affectedToDate}
                                                                            onChange={(e) => setAffectedToDate(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    {/* levpo_flag checkbox - Apply to All Staff */}
                                                                    <div className="col-sm-4 mt-3">
                                                                        <h6>Apply to All Staff</h6>
                                                                        <div className="form-check" style={{ marginTop: "12px" }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="levpoFlagCheckbox"
                                                                                checked={levpoFlag}
                                                                                onChange={(e) => setLevpoFlag(e.target.checked)}
                                                                                style={{
                                                                                    width: "14px",
                                                                                    height: "14px",
                                                                                    cursor: "pointer",
                                                                                    accentColor: "#2f5bea"
                                                                                }}
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="levpoFlagCheckbox"
                                                                                style={{
                                                                                    marginLeft: "8px",
                                                                                    cursor: "pointer",
                                                                                    fontSize: "0.95rem",
                                                                                    color: "#2f3b52"
                                                                                }}
                                                                            >
                                                                                {levpoFlag
                                                                                    ? "This policy applies to all staff"
                                                                                    : "Check to apply this policy to all staff"
                                                                                }
                                                                            </label>
                                                                        </div>
                                                                    </div>






                                                                </div>






                                                            </div>


                                                            {/* test */}

                                                            <div className="col-12 d-flex justify-content-center mt-4">
                                                                <button type="button" className="btn btn-primary mb-2" onClick={handleSubmit} disabled={loading}>
                                                                    {loading ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                            Submitting...
                                                                        </>
                                                                    ) : (
                                                                        "Submit"
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {isTableVisible && (
                                                    <div className="col-xl-6 col-xxl-12">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <div className="basic-form">
                                                                    <div className="form-row">
                                                                        <div className="table-responsive" style={{ display: isTableVisible ? 'block' : 'none' }}>
                                                                            {isTableVisible && (
                                                                                <table className="table table-bordered table-responsive-sm mt-4">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>Type</th>
                                                                                            <th>Allotted</th>
                                                                                            <th>Delete</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {groupedSelectedLeaves.map((leave) => (
                                                                                            <tr key={`leave-${leave.leaveid}`}>
                                                                                                <td>{leave.leave_type}</td>
                                                                                                <td>{leave.max_leave}</td>
                                                                                                <td>

                                                                                                    <i
                                                                                                        className="text-danger fa fa-close"
                                                                                                        style={{ cursor: "pointer" }}
                                                                                                        onClick={() => handleDeleteByLeaveType(leave.leaveid)}
                                                                                                    ></i>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            )}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddLeavePolicy;